export enum WebhookEvent {
  NewCandidate = 'new_candidate',
  CandidateAssigned = 'candidate_assigned',
  CandidateMoved = 'candidate_moved',
  CandidateDeleted = 'candidate_deleted',
  OfferPublished = 'offer_published',
  OfferUnpublished = 'offer_unpublished',
}

export const WEBHOOK_EVENTS = [
  WebhookEvent.NewCandidate,
  WebhookEvent.CandidateAssigned,
  WebhookEvent.CandidateMoved,
  WebhookEvent.CandidateDeleted,
  WebhookEvent.OfferPublished,
  WebhookEvent.OfferUnpublished,
];
